export default __webpack_public_path__ + "static/media/dots.026b9b7f.svg";